module.exports = __webpack_public_path__ + "img/day_light.4e39e6b.webp";